import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';

import { Dropdown, DropdownProps } from './Dropdown';


export type IconButtonDropdownProps = Omit<DropdownProps, 'children'> & {
  buttonProps?: IconButtonProps;
  children?: React.ReactNode;
}

export const IconButtonDropdown: React.FC<IconButtonDropdownProps> = ({ children, buttonProps, ...props }) => (
  <Dropdown {...props}>
    {({ ref, handleToggleDropdownMenu }) => (
      <IconButton
        {...buttonProps}
        ref={ref}
        onClick={handleToggleDropdownMenu}
      >
        {children}
      </IconButton>
    )}
  </Dropdown>
);
